import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const FooterLogo = ({ image }) => {

      const location = useLocation();
    
      const handleHomeClick = (e) => {
        if (location.pathname === "/") {
          e.preventDefault();
          // Optional: Scroll smoothly to top if you want that behavior
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      };
    return (
        <Link to={process.env.PUBLIC_URL + "/"}
        onClick={handleHomeClick}>
            <img className="footer-logo" src={process.env.PUBLIC_URL + image} alt="Footer Logo" />
        </Link>
    );
};

export default FooterLogo;